var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", [_vm._v("Offices")]),
      _vm._v(" "),
      _c("p", [_vm._v("Add, remove and edit office location(s).")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-default btn-create",
          staticStyle: { "margin-top": "0px", "margin-left": "0px" },
          attrs: { type: "button" },
          on: { click: _vm.createNewOffice }
        },
        [_vm._v("\n    Create new office\n  ")]
      ),
      _vm._v(" "),
      _vm._l(_vm.officeList, function(office, index) {
        return _c(
          "div",
          [_c("inputForm", { key: office.id, attrs: { index: index } })],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-708f1f10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-708f1f10","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/offices.vue
// module id = 179
// module chunks = 0